import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import type {AvailabilityDay} from 'nutshell-graphql-types';
import type {SetAvailability_availabilitySet_availability_times as AvailabilityTime} from 'nutshell-graphql-types';

import {DayRow} from './day-row';
import {DAYS_OF_WEEK, bucketAvailabilityTimesByDay} from './helpers';

type Props = {
    availabilityTimes: AvailabilityTime[];
    setAvailabilityTimes: (arg1: AvailabilityTime[]) => void;
};

export function DaysConfig(props: Props) {
    const handleSaveRow = (updatedTimes: AvailabilityTime[], day: AvailabilityDay) => {
        const availabilityTimesByDay = bucketAvailabilityTimesByDay(props.availabilityTimes);
        // @ts-expect-error
        const updatedAvailabilityTimes = [];

        DAYS_OF_WEEK.forEach((dayOfWeek) => {
            if (dayOfWeek === day) {
                updatedAvailabilityTimes.push(...updatedTimes);
            } else {
                updatedAvailabilityTimes.push(...availabilityTimesByDay[dayOfWeek]);
            }
        });

        // @ts-expect-error
        props.setAvailabilityTimes(updatedAvailabilityTimes);
    };

    return (
        <StackLegacy spacing={8}>
            {DAYS_OF_WEEK.map((dayOfWeek) => {
                return (
                    <DayRow
                        key={dayOfWeek}
                        dayOfWeek={dayOfWeek}
                        availabilityTimes={props.availabilityTimes.filter(
                            (time) => time.day === dayOfWeek
                        )}
                        onChange={(availabilityTimes) => {
                            handleSaveRow(availabilityTimes, dayOfWeek);
                        }}
                    />
                );
            })}
        </StackLegacy>
    );
}
